/* Sold Attire: demote sold cards within each rendered collection grid batch.
   Available items lead, sold items follow. Collection pages only. No fetch,
   no re-render, moves existing DOM nodes only. No-op guard prevents
   self-triggering MutationObserver loops. Fresh selectors every run. */
(function () {
  'use strict';

  function reorderGrid(list) {
    var cards = list.querySelectorAll(':scope > product-card[handle]');
    if (cards.length < 2) return;

    var sold = [];
    var seenSold = false;
    var needsReorder = false;

    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-available') === 'false') {
        sold.push(cards[i]);
        seenSold = true;
      } else if (seenSold) {
        needsReorder = true;
      }
    }

    if (!needsReorder || !sold.length) return;
    for (var j = 0; j < sold.length; j++) list.appendChild(sold[j]);
  }

  function reorderAllGrids() {
    try {
      var lists = document.querySelectorAll('product-list[id^="product-list-"]');
      for (var i = 0; i < lists.length; i++) reorderGrid(lists[i]);
    } catch (e) {
      /* fail silent */
    }
  }

  function init() {
    reorderAllGrids();
    try {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          reorderAllGrids();
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      /* fail silent */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
